import axios from 'axios';
import ACTION_ITEMS from '../actionItems';

export function getSessionState(userId) {
  return (dispatch) => {
    axios
      .get(`/candidate/${userId}/session-state`)
      .then((response) => {
        const { status, sessionState } = response.data;
        if (status === 'SUCCESS') {
          dispatch(setSessionState(sessionState));
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };
}

function setSessionState(sessionState) {
  return {
    type: ACTION_ITEMS.CANDIDATE_PORTAL.SESSION_STATE.SET,
    payload: { sessionState },
  };
}
